import {Suspense} from 'react'
import {HgButton, HgHamburger, HgTextLink} from '~/design-system/hg/components'
import HgChevronIndicator from '~/design-system/hg/components/HgNavigation/HgChevronIndicator'
import {cn} from '~/design-system/utils'
import {internalLinks} from '~/routing/internal-links'
import mobileNavVariants from '../../HgNavbar/_variants/mobileNavVariants'
import {type HgBlogNavbarProps} from '../types'
import HgBlogNavbarMenu from './HgBlogNavbarMenu'
import {useBlogNavbarContext} from './HgBlogNavbarProvider'
import HgBlogNavSearch from './HgBlogNavSearch'

export default function HgBlogNav({
  className,
  isScrolled,
  ...props
}: HgBlogNavbarProps & {className?: string; isScrolled?: boolean}) {
  const {
    toggleSearch,
    toggleNav,
    state: {navOpen, isResizing, isSearchPage},
  } = useBlogNavbarContext()

  const {bar} = mobileNavVariants({
    navOpen,
    isBlog: true,
    disableAnimation: isResizing,
    isScrolled,
  })

  return (
    <nav
      className={bar({
        className: cn(
          'w-screen border-y border-border-frosted px-s5 py-s2',
          className
        ),
      })}
    >
      <div className="flex grow basis-0 items-center">
        <HgTextLink
          variant="revealUnderline"
          href={internalLinks.blogHomepage}
          className="arcadia-ui-2"
        >
          Blog
        </HgTextLink>
      </div>
      <ul className="hidden gap-s6 arcadia-ui-2 lg:flex">
        {props.categoryLinks.categories.map(category => (
          <li key={category.name}>
            <HgTextLink variant="revealUnderline" href={category.href}>
              {category.name}
            </HgTextLink>
          </li>
        ))}
      </ul>
      <div className="flex grow basis-0 items-center justify-end gap-s1 lg:gap-0">
        <HgButton
          variant="text"
          size="small"
          onClick={toggleNav}
          className="group hidden gap-4 lg:flex"
          data-state={navOpen ? 'open' : 'closed'}
        >
          Topics
          <HgChevronIndicator />
        </HgButton>
        {!isSearchPage && (
          <HgButton
            onClick={toggleSearch}
            iconProps={{iconType: 'search'}}
            contentType="icon"
            aria-label="Search"
            variant="text"
            size="small"
          />
        )}

        <button onClick={toggleNav} className="lg:hidden">
          <span className="sr-only">{navOpen ? 'Close Menu' : 'Open Menu'}</span>
          <HgHamburger navOpen={navOpen} />
        </button>
      </div>
      <Suspense>
        <HgBlogNavSearch />
      </Suspense>
      <HgBlogNavbarMenu {...props} />
    </nav>
  )
}
